import { healthValues } from '@/mocks/kunlun-data';

export default function HealthValues() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-[0.2em] text-accent-600 uppercase font-heading">
            HEALTH VALUE
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
            健康价值
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            昆仑雪冰川水不仅仅是一瓶水，更是大自然赋予人类的珍贵健康礼物，蕴含六大核心健康价值
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {healthValues.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-2xl p-6 md:p-7 hover:bg-background-200/70 transition-colors duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}